// extracted by mini-css-extract-plugin
export default {"paragraphLine1":"ParagraphLoader_paragraphLine1__IOyeH","paragraphLine2":"ParagraphLoader_paragraphLine2__Jlwq2","paragraphLine3":"ParagraphLoader_paragraphLine3__eOEvS"};